import { MessageCircle } from 'lucide-react';

export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/967783338339"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل معنا عبر واتساب"
      className="fixed bottom-8 right-8 md:bottom-12 md:right-12 z-[100] w-[4.5rem] h-[4.5rem] bg-primary-600 hover:bg-primary-500 text-white rounded-full flex items-center justify-center shadow-[0_0_20px_rgba(224,0,0,0.5)] hover:shadow-[0_0_35px_rgba(224,0,0,0.7)] transition-all duration-300 hover:scale-110 animate-[pulse_3s_ease-in-out_infinite] group border-4 border-white dark:border-zinc-950"
    >
      <MessageCircle className="w-8 h-8 group-hover:-translate-y-0.5 transition-transform" />

      {/* Tooltip */}
      <span className="absolute right-full ml-4 whitespace-nowrap bg-zinc-900 dark:bg-white text-white dark:text-zinc-900 px-4 py-2 rounded-xl text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none transform -translate-x-4 group-hover:translate-x-0 hidden sm:block">
        طلب مساعدة؟
        <div className="absolute left-full top-1/2 -translate-y-1/2 border-[6px] border-transparent border-l-zinc-900 dark:border-l-white"></div>      </span>
    </a>
  );
}
